import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "drop-down-menu-item__wrapper s-px-2 s-pt-2 s-pb-1",
  "data-test": "group-menu-item"
}
const _hoisted_2 = { class: "headlines--headline-01 text-core-primary-10" }

interface Props {
  group?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropDownMenuGroupItem',
  props: {
    group: { default: '' }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.group), 1)
  ]))
}
}

})